import defaultCountryCode from '@spa/lib/configs/defaultCountryCode';
import readStringEnv from './services/readStringEnv';

const multiCountryExperimentsSettings: Record<string, Record<string, number>> = JSON.parse(
  readStringEnv(process.env.STOREFRONT_EXPERIMENTS) ?? '{}'
);

const experimentsSettings: Record<string, number> =
  multiCountryExperimentsSettings[defaultCountryCode] ?? {};

export default experimentsSettings;
